import { render, staticRenderFns } from "./BAEventLocationAdminPage.vue?vue&type=template&id=497e0b0c&scoped=true&"
import script from "./BAEventLocationAdminPage.vue?vue&type=script&lang=ts&"
export * from "./BAEventLocationAdminPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e0b0c",
  null
  
)

export default component.exports